import Select from "./Select";
import type { dataSelectProps } from "./types.props";

const DataSelect = ({ options, placeholder, ...rest }: dataSelectProps) => {
    return (
        <Select {...rest}>
            {placeholder && (
                <option value="" disabled>
                    {placeholder}
                </option>
            )}
            {options.map((opt) => (
                <option key={opt.value} value={opt.value} disabled={opt.disabled}>
                    {opt.label}
                </option>
            ))}
        </Select>
    );
};

export default DataSelect;
